(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      // Position header below announcement bar dynamically
      if (document.body.classList.contains('template-index')) {
        this.positionBelowAnnouncement();
        window.addEventListener('resize', this.positionBelowAnnouncement.bind(this));
        
        document.addEventListener('click', () => {
          setTimeout(() => this.updateTransparency(), 50);
          setTimeout(() => this.updateTransparency(), 200);
          setTimeout(() => this.updateTransparency(), 500);
        });
      }
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Transparent header scroll logic (homepage only)
      if (document.body.classList.contains('template-index')) {
        this.headerWrapper = document.querySelector('.header-wrapper');
        this.updateTransparency();
        window.addEventListener('scroll', this.updateTransparency.bind(this));
      }
    }

updateTransparency() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      const annBar = headerGroup ? headerGroup.children[0] : null;
      const annBottom = annBar ? Math.max(0, annBar.getBoundingClientRect().bottom) : 0;
      
      if (this.headerWrapper) {
        this.header.style.top = annBottom + 'px';
        
        if (scrollTop > 80) {
          this.headerWrapper.classList.add('header-scrolled');
          this.header.classList.add('header-scrolled-section');
        } else {
          this.headerWrapper.classList.remove('header-scrolled');
          this.header.classList.remove('header-scrolled-section');
        }
      }
    }

    positionBelowAnnouncement() {
      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      const announcementBar = headerGroup ? headerGroup.children[0] : null;
      const sectionHeader = document.querySelector('.section-header');
      const headerWrapper = document.querySelector('.header-wrapper');
      const firstBanner = document.querySelector('#MainContent .shopify-section:first-child .banner');

      if (announcementBar && sectionHeader) {
        const announcementHeight = announcementBar.getBoundingClientRect().height;
        sectionHeader.style.top = announcementHeight + 'px';
      }

      if (headerWrapper) {
        const announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
        const headerHeight = headerWrapper.getBoundingClientRect().height;
        const totalHeight = announcementHeight + headerHeight;
        const imageBanner = document.querySelector('#MainContent .shopify-section:nth-child(2)');
        if (imageBanner) {
          imageBanner.style.paddingTop = headerHeight + 'px';
          const gap = window.innerWidth >= 750 ? 35 : 23;
          imageBanner.style.marginTop = '-' + gap + 'px';
        }
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      return;
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
